'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'tag';
var width = 512;
var height = 512;
var aliases = [127991];
var unicode = 'f02b';
var svgPathData = 'M288 489.4L48 249.4 48 48 249.4 48 489.4 288 288 489.4zM500.7 276.7L256 32 32 32 32 256 288 512 512 288 500.7 276.7zM144 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTag = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;